import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import ItemTypeFilterModal from '.';
import { Filter } from 'iconsax-react';
import { useClickAway } from '@uidotdev/usehooks';
import { useTranslation } from 'react-i18next';
import { ICommonCode } from 'utils/types/storyTypes';

interface IProps {
  filterList: ICommonCode[];
  setItemFilter: React.Dispatch<React.SetStateAction<string[]>>;
  itemFilter: string[];
}

const ColumnItem: React.FC<IProps> = ({
  filterList,
  itemFilter,
  setItemFilter,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickAway(() => {
    setIsOpen(false);
  });

  const handleOpenModal = () => {
    if (isOpen === false) {
      setIsOpen(true);
    }
  };
  return (
    <DropdownFilterWrapper ref={ref} onClick={handleOpenModal}>
      <div className='filter-wrapper'>
        <p>
          {t('storyEpisodeID.storyTabMenuList.operationContent.table.itemType')}
        </p>
        <Filter size='20' color={theme.colors.dark_200} />
      </div>
      {isOpen && (
        <ItemTypeFilterModal
          filterList={filterList}
          setItemFilter={setItemFilter}
          itemFilter={itemFilter}
        />
      )}
    </DropdownFilterWrapper>
  );
};

export default ColumnItem;

const DropdownFilterWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  .filter-wrapper {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    & > * + * {
      margin-left: 10px;
    }
  }
`;
